import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

const sbOfficeLicenseService = {
  async getTenants() {
    const response = await api.get("/sboffice-license");
    return response.data;
  },

  async getTenant(id) {
    const response = await api.get(`/sboffice-license/${id}`);
    return response.data;
  },

  async getMyTenant() {
    const response = await api.get("/sboffice-license/my");
    return response.data;
  },

  async createTenant(payload) {
    const response = await api.post("/sboffice-license", payload);
    return response.data;
  },

  async updateTenant(id, payload) {
    const response = await api.put(`/sboffice-license/${id}`, payload);
    return response.data;
  },

  async updateMandantStatus(id, mandantId, status) {
    const response = await api.put(`/sboffice-license/${id}/mandants/${mandantId}/status`, { status });
    return response.data;
  },

  async deleteTenant(id) {
    const response = await api.delete(`/sboffice-license/${id}`);
    return response.data;
  },
};

export default sbOfficeLicenseService;
